import { Card, Stack, Typography } from "@mui/material";

import { useAppSelector } from "Hooks/useRedux";
import { useEffect, useState } from "react";

const colors = [
  [
    "#00887A",
    "#089180",
    "#109986",
    "#18A28C",
    "#20AA93",
    "#28B399",
    "#30BB9F",
    "#38C4A5",
    "#3FCCAB",
    "#47D5B1",
    "#4FDDB7",
    "#57E6BE",
    "#5FEEC4",
    "#67F7CA",
    "#6FFFD0",
  ],
  [
    "#21296B",
    "#273674",
    "#2C437D",
    "#325086",
    "#375C8E",
    "#3D6997",
    "#4276A0",
    "#4883A9",
    "#4E90B2",
    "#539DBB",
    "#59AAC4",
    "#5EB6CC",
    "#64C3D5",
    "#69d0de",
    "#6FDDE7",
  ],
];

const colors2 = [
  ["#d67540", "#c6a006", "#cad004", "#5d910c", "#76c52b", "#cdfc9e"],
  ["#461f69", "#6e246d", "#3744aa", "#19c6ba", "#70f8f0", "#92fcea"],
];

const colors3 = [
  ["#44b30699", "#5ed71999", "#9feb7499"],
  ["#008fd599", "#14abf599", "#8fd6f999"],
];

export function Spectrum() {
  const { heatMap2Mode, colorStep } = useAppSelector((state) => state.zones);
  const [selectedColorList, setSelectedColorList] = useState<string[]>(colors[0]);
  const { stationLayer } = useAppSelector((state) => state.layers);

  const numbers = [
    [1200, 800, 700, 500, 400, 200, 100, 70, 50, 40, 30, 20, 10, 5],
    [800, 500, 400, 300, 250, 120, 60, 40, 30, 20, 15, 10, 6, 3],
    [400, 250, 200, 150, 100, 70, 40, 25, 20, 15, 10, 6, 3, 1],
    [240, 160, 140, 100, 80, 40, 20, 15, 10, 8, 6, 4, 2, 1],
    [120, 80, 70, 50, 40, 20, 10, 7, 6, 5, 4, 3, 2, 1],
  ];

  useEffect(() => {
    if (heatMap2Mode === "destination") {
      setSelectedColorList(colors[1]);
    } else if (heatMap2Mode === "source") {
      setSelectedColorList(colors[0]);
    }
  }, [heatMap2Mode]);

  const setTopColor = (index: number) => {
    if (index > 8 && heatMap2Mode === "destination") {
      return "#21296b";
    }
    if (index > 8 && heatMap2Mode === "source") {
      return "#21296b";
    }
    return "#fff";
  };

  return (
    <div style={{ width: "100%" }}>
      <p
        style={{
          fontSize: "14px",
          backgroundColor: "#ffffff80",
          display: "inline",
          padding: "3px 8px",
          borderRadius: "7px 7px 0 0",
          zIndex: stationLayer,
        }}
      >
        {" "}
        تقاضای سرویس
      </p>
      <ul style={{ display: "flex", listStyle: "none", width: "100%" }}>
        {selectedColorList.map((c, index) => (
          <li
            style={{
              width: "6%",
              backgroundColor: c,
              fontSize: "13px",
              opacity: "0.8",
              padding: "2px 0",
              color: setTopColor(index),
              textAlign: "center",
            }}
          >
            <strong> {index === 0 ? "∞" : numbers[colorStep - 1][index - 1]}</strong>
          </li>
        ))}
      </ul>
    </div>
  );
}

export function Spectrum2() {
  const { heatmapMode } = useAppSelector((state) => state.surveys);
  const [selectedColorList, setSelectedColorList] = useState<string[]>(colors[0]);

  const numbers = ["100%", "80%", "60%", "50%", "30%", "10%"];

  useEffect(() => {
    if (heatmapMode === "destination") {
      setSelectedColorList(colors2[1]);
    } else if (heatmapMode === "source") {
      setSelectedColorList(colors2[0]);
    }
  }, [heatmapMode]);

  const setTopColor = (index: number) => {
    if (index > 2 && heatmapMode === "destination") {
      return "#21296b";
    }
    if (index > 1 && heatmapMode === "source") {
      return "#21296b";
    }
    return "#fff";
  };

  return (
    <div style={{ width: "100%" }}>
      <p
        style={{
          fontSize: "14px",
          backgroundColor: "#ffffff80",
          display: "inline",
          padding: "3px 8px",
          borderRadius: "7px 7px 0 0",
        }}
      >
        {" "}
        تقاضای سرویس
      </p>
      <ul style={{ display: "flex", listStyle: "none", width: "100%" }}>
        {selectedColorList.map((c, index) => (
          <li
            style={{
              width: "6%",
              backgroundColor: c,
              fontSize: "13px",
              opacity: "0.8",
              padding: "2px 0",
              color: setTopColor(index),
              textAlign: "center",
            }}
          >
            <strong> {numbers[index]}</strong>
          </li>
        ))}
      </ul>
    </div>
  );
}

export function Spectrum3() {
  const { markerMode } = useAppSelector((state) => state.surveys);
  const [selectedColorList, setSelectedColorList] = useState<string[]>(colors[0]);

  const numbers = [100, 50];

  useEffect(() => {
    if (markerMode.includes("destination")) {
      setSelectedColorList(colors3[1]);
    } else if (markerMode.includes("source")) {
      setSelectedColorList(colors3[0]);
    }
  }, [markerMode]);

  return (
    <div style={{ width: "100%" }}>
      <p
        style={{
          fontSize: "14px",
          backgroundColor: "#ffffff80",
          display: "inline",
          padding: "3px 8px",
          borderRadius: "7px 7px 0 0",
        }}
      >
        {" "}
        تقاضای سرویس
      </p>
      {markerMode.includes("destination") ? (
        <ul style={{ display: "flex", listStyle: "none", width: "100%" }}>
          {colors3[1].map((c, index) => (
            <li
              style={{
                width: "6%",
                backgroundColor: c,
                fontSize: "13px",
                opacity: "0.8",
                padding: "2px 0",
                color: "#21296b",
                textAlign: "center",
              }}
            >
              <strong> {index === 0 ? "∞" : numbers[index - 1]}</strong>
            </li>
          ))}
        </ul>
      ) : null}
      {markerMode.includes("source") ? (
        <ul style={{ display: "flex", listStyle: "none", width: "100%" }}>
          {colors3[0].map((c, index) => (
            <li
              style={{
                width: "6%",
                backgroundColor: c,
                fontSize: "13px",
                opacity: "0.8",
                padding: "2px 0",
                color: "#21296b",
                textAlign: "center",
              }}
            >
              <strong> {index === 0 ? "∞" : numbers[index - 1]}</strong>
            </li>
          ))}
        </ul>
      ) : null}
    </div>
  );
}
